<template>
    <div class="newsCenter">
        <div class="main">

            <div class="right" v-if="type == 0" style="padding-bottom: 0;">
                <div class="newsItem" v-for="(item, index) in newsList" @click="newsItem(item)" v-if="count == 0">

                     {{ item.contentTitle }}

                </div>


            </div>

        </div>

    </div>
</template>
<script>
import { menu, contentPage } from '../api/api'
export default {
    name: 'aboutUsTemplate',
    data() {
        return {
            list: [],//二级菜单数组
            // parentId: this.$route.query.parentId || '',//二级菜单数组id
            count: 0,
            newsList: [],
            type: 0,
            pageNum: 1,
            pageSize: 10,
            total: 0,
            menuId: '',
            contentDetails: '',//详情
            search: this.$route.query.search || '',
        }
    },
    created() {
        this.getContentPage()//二级菜单数组
    },
    watch: {
        $route(to, from) {
            console.log(to, 'to');
            this.search = to.query.search
            this.getContentPage()//二级菜单
        },
    },
    methods: {
        getSimpleText(html) {
            const re1 = new RegExp("<.+?>", "g"); // 匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
            const arrEntities = { 'lt': '<', 'gt': '>', 'nbsp': ' ', 'amp': '&', 'quot': '"', 'ldquo': '“', 'mdash': '—', "rdquo": '”' };
            return html.replace(re1, '').replace(/&(lt|gt|nbsp|amp|quot|ldquo|mdash|rdquo);/ig, function (all, t) {
                return arrEntities[t];
            });
        },
        //二级菜单数组
        // getList() {
        //     menu(this.parentId).then(res => {
        //         this.list = res.data
        //         this.menuId = this.list[0].menuId
        //         this.getContentPage()
        //     })
        // },
        getContentPage() {
            contentPage(this.pageNum, this.pageSize, 2143, this.search, null).then(res => {
                this.newsList = res.data
                this.total = res.total
                console.log(this.newsList, 'this.newsList = res.data');
                // this.snckData = res.data
            })
        },
        barClick(index) {
            this.count = index
            this.type = 0
            this.menuId = this.list[index].menuId
            this.getContentPage()
        },
        newsItem(item) {
            this.type = 1
            console.log(item, 'item');
            this.contentDetails = item.contentDetails
        },
        handleCurrentChange(e) {
            this.pageNum = e
            this.getContentPage()
            console.log(`当前页: ${e}`);
        }
    }
}
</script>




<style scoped lang="scss">
.newsCenter {
    width: 100vw;
    display: flex;
    justify-content: center;
    background: #F5F5F5;
    padding-bottom: 50px;
}

.main {
    // display: flex;
    width: 1300px;
    padding-top: 47px;

}





</style>


// WEBPACK FOOTER //
// src/components/search.vue